import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CHANNEL = (process.env.REACT_APP_CONTACT_CHANNEL || "whatsapp").toLowerCase();
const ENV_WA = (process.env.REACT_APP_WHATSAPP_NUMBER || "").replace(/\D/g, "");
const TG_USER = (process.env.REACT_APP_TELEGRAM_USERNAME || "").replace(/^@/, "").trim();

export const CONTACT_CHANNEL = CHANNEL === "telegram" && TG_USER ? "telegram" : "whatsapp";

let waPromise = null;
const fetchWaNumber = () => {
  if (ENV_WA) return Promise.resolve(ENV_WA);
  if (!waPromise) {
    waPromise = axios.get(`${API}/contact`).then((r) => r.data.wa_number || "").catch(() => "");
  }
  return waPromise;
};

export const getContactLink = async (message = "") => {
  if (CONTACT_CHANNEL === "telegram") return `https://t.me/${TG_USER}`;
  const wa = await fetchWaNumber();
  if (!wa) return null;
  return `https://wa.me/${wa}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
};

export const useContactLink = (message = "") => {
  const [link, setLink] = useState(null);
  useEffect(() => {
    let active = true;
    getContactLink(message).then((l) => { if (active) setLink(l); });
    return () => { active = false; };
  }, [message]);
  return link;
};
